import { useEffect, useState, type JSX } from 'react';
import { useAtom } from 'jotai';
import { NoticeMessageState } from 'stores/atoms/noticeMessageState';

import { isEmpty } from 'utils/app';

/**
 * メッセージ通知コンポーネント
 */
export default function NotificationMessage(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  type MessageType = {
    message: string;
    status: string;
    time: number;
  };
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [noticeMessageState] = useAtom(NoticeMessageState);

  const [messages, setMessages] = useState([]);
  const [timer, setTimer] = useState(0);

  // メッセージの表示時間
  const noticeMessageDisplayMs = 3000;
  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    (async () => {
      if (isEmpty(noticeMessageState.message)) {
        return;
      }
      setMessages(m => [...m, { ...noticeMessageState, time: new Date().getTime() }]);
      setTimeout(
        function () {
          setTimer(new Date().getTime());
        }.bind(this),
        noticeMessageDisplayMs
      );
    })();
  }, [noticeMessageState]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- タイマーに連動した状態更新のため意図的
    setMessages(m => m.filter(item => timer - item.time < noticeMessageDisplayMs));
  }, [timer]);

  const clearMessages = (message: MessageType) => {
    const newMessages = messages.filter(item => item !== message);
    setMessages(newMessages);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <div className="notification-message">
        {messages.map(item => {
          return (
            <p
              key={item.time}
              onClick={() => clearMessages(item)}
              className={`btn-xmark ms-5 ${item.status}`}
            >
              {item.message}
            </p>
          );
        })}
      </div>
    </>
  );
}
